export default "__VITE_ASSET__DgoT00kx__"